import * as f from './_cmFTH';

import * as _hm from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

export const itlI20z = () => ({ // 新規登録を考慮し、毎回新規生成
  i20rz: {},
}) as ht.dz;

export const crtI20z = async () => {
  const _i20z = itlI20z();
  _hm.udtDz(_i20z.i20rz, {
    ... ihd.i('i20r'),
  });
  return _i20z;
};

export const loadI20rLsAsync = async (
) => {
  const _cdn = f.vdd(true, false);
  const _ls = await f.loadLsAsync({
    tgt: 'i20rs',
    cdn: _cdn,
    fld: '*',
  });
  return _ls;
};

export const loadI20rDzAsync = async (pz?: { // ドメイン共通のため i20r_fst を指定しない
}) => {
  const _cdn = f.vdd(true, false);
  const _dz = await f.loadDzAsync({
    tgt: 'i20rs',
    cdn: _cdn,
  });
  return {
    i20rz: { ... _dz, cldz: undefined },
  };
};

export const saveI20rDzAsync = async (pz: {
  i20z: ht.dz,
  sPz?: ht.dz,
}) => {
  //_hm.l(`icvI20__Mz 46a: ${_hm.s(pz.i20z)}`)
  const _dz = await f.ugdDzAsync({
    tgt: 'i20rs',
    dmn: 0,
    dz: {
      ... pz.i20z.i20rz,
    },
  });
  return {
    i20rz: { ... _dz, cldz: undefined },
  };
};
